import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Heart, Shield, Users } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-5xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary mb-8">
            <ArrowLeft className="h-4 w-4" /> Back home
          </Link>
          <p className="overline mb-4">Our story</p>
          <h1 className="font-serif text-5xl sm:text-6xl tracking-tighter text-primary leading-[1.05] mb-8">
            Built on faith.<br />
            Designed for families.<br />
            <span className="italic text-accent">Funded by purpose.</span>
          </h1>
          <p className="max-w-2xl text-lg leading-relaxed text-muted-foreground">
            Faith Family Finance was founded on a single belief: that protecting the people you love
            shouldn&rsquo;t feel like a sales pitch. We&rsquo;re an independent brokerage representing more than
            two dozen A-rated carriers, which means we work for you &mdash; not for any single insurance company.
          </p>

          <div className="grid md:grid-cols-3 gap-6 mt-16">
            {[
              { icon: Heart, title: "Family first", body: "Every recommendation starts with your people and your priorities." },
              { icon: Shield, title: "Carrier neutral", body: "We compare 25+ A-rated carriers so the best policy wins, not the highest commission." },
              { icon: Users, title: "Lifetime service", body: "Your agent stays your agent. Real human support whenever life changes." },
            ].map(({ icon: Icon, title, body }) => (
              <div key={title} className="rounded-3xl border border-border/60 bg-card p-8 soft-shadow">
                <Icon className="h-6 w-6 text-accent mb-4" strokeWidth={1.5} />
                <h3 className="font-serif text-2xl text-primary mb-2">{title}</h3>
                <p className="text-sm leading-relaxed text-muted-foreground">{body}</p>
              </div>
            ))}
          </div>

          <div className="mt-20">
            <Link to="/#quote">
              <Button size="lg" className="rounded-full px-8 h-12 bg-primary hover:bg-primary/90">
                Request your free quote
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
